(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-05-recommendation-product"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          function initSlider() {
            $('.jl-carousel__list--async').each(function () {
              $(this).slick({
                infinite: true,
                slidesToShow: 4,
                arrows: true,
                autoplay: true,
                nextArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--next'),
                prevArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--prev'),
              });
            });

            window.addEventListener('resize', function () {
              if (window.innerWidth <= 767) {
                $('.jl-carousel__list--async').each(function () {
                  $(this).slick('unslick');
                });
              }
            });
          }

          if (window.innerWidth > 767) {
            initSlider();
          }

          window.addEventListener('resize', function () {
            if (window.innerWidth > 767) {
              initSlider();
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
